import React, { useMemo } from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { createGoogleMapsJsLoaderProps, getMapsApiKeyFromEnv } from "../maps/googleMapsLoader";

function MatchVenueMapInner({ latitude, longitude, title, apiKey }) {
  const center = useMemo(
    () => ({
      lat: latitude,
      lng: longitude
    }),
    [latitude, longitude]
  );

  const loaderOpts = useMemo(() => createGoogleMapsJsLoaderProps(apiKey), [apiKey]);

  const { isLoaded, loadError } = useJsApiLoader(loaderOpts);

  if (loadError || !isLoaded) {
    return null;
  }

  return (
    <div className="match-venue-map" role="img" aria-label={title ? `Map: ${title}` : "Venue map"}>
      <GoogleMap
        mapContainerClassName="match-venue-map__canvas"
        center={center}
        zoom={14}
        options={{
          draggable: false,
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
          zoomControl: true,
          scrollwheel: false,
          disableDoubleClickZoom: true
        }}
      >
        <Marker position={center} title={title} />
      </GoogleMap>
    </div>
  );
}

function MatchVenueMap({ latitude, longitude, title }) {
  const apiKey = getMapsApiKeyFromEnv();
  if (!apiKey) {
    return (
      <p className="muted small match-venue-map__placeholder">
        Map preview unavailable. Use Open in Google Maps below.
      </p>
    );
  }

  return (
    <MatchVenueMapInner latitude={latitude} longitude={longitude} title={title} apiKey={apiKey} />
  );
}

export default MatchVenueMap;
